import { useQueryClient } from "@tanstack/react-query";
import { CirclePause } from "lucide-react";
import { useState } from "react";

import { Button } from "../components/ui";
import { Waiting } from "../components/Waiting";
import { t } from "../i18n/i18n";
import { LicenceFrame } from "./ActivationScreen";
import { LICENCE_QUERY } from "./licence";

/** Licence suspendue par BELLICOM (administration des licences, 02/11/2026) : rien n'est effacé, les dossiers
 *  reviennent tels quels au rétablissement ; l'écran dit qui joindre. L'état est relu toutes les deux minutes par le
 *  portail, et à la demande. `kept` : par-dessus l'application, dont les saisies en cours sont gardées. */
export function SuspendedScreen({ kept = false }: { kept?: boolean }) {
  const queryClient = useQueryClient();
  const [checking, setChecking] = useState(false);
  const recheck = async () => {
    setChecking(true);
    try {
      await queryClient.invalidateQueries({ queryKey: LICENCE_QUERY });
    } finally {
      setChecking(false);
    }
  };
  return (
    <LicenceFrame kept={kept}>
      <h1 className="flex items-center gap-2 text-title font-semibold text-ink">
        <CirclePause size={16} className="text-ink-muted" /> {t("Licence suspendue")}
      </h1>
      <p className="mt-1.5 text-ui leading-relaxed text-ink-soft">
        {t("BELLICOM a suspendu cette licence : Generex est fermé sur ses postes pour le moment.")}
      </p>
      <p className="mt-2 text-ui leading-relaxed text-ink-soft">
        {t("Vos dossiers d'exercice sont conservés et vous les retrouverez tels quels dès son rétablissement.")}
      </p>
      <p className="mt-2 text-ui leading-relaxed text-ink-soft">
        {t("Pour toute question, écrivez à")}{" "}
        <a className="font-medium text-accent underline-offset-2 hover:underline" href="mailto:contact@bellicom.fr">
          contact@bellicom.fr
        </a>
        .
      </p>
      <Button className="mt-5 w-full" variant="secondary" disabled={checking} onClick={() => void recheck()}>
        {checking ? <Waiting>{t("Vérification…")}</Waiting> : t("Vérifier de nouveau")}
      </Button>
    </LicenceFrame>
  );
}
